import { GET_AGENT_CODE, GET_QUOTE_REQUEST, SEND_LEADS_EMAIL, SEND_UPLOAD_DOCUMENTS, SUBMIT_POLICY_REQUEST } from "../../../actions/sizotsaFuneralCover/policyRequest";
import { SIZOTSA_REFERENCE_DATA_SERVICE } from "../../../actions/sizotsaFuneralCover/referenceData";
import { sizotsaLeadsMailService } from "./leadsMailService";
import { purchaseService } from "./purchaseService";
import { quoteService } from "./quotingService";
import { referenceDataService } from "./referenceData";
import { uploadDocumentService } from "./uploadDocuments";

export const sizotsaFuneralCoverServices=(store, next, action)=>{
    if (action.type.startsWith(SIZOTSA_REFERENCE_DATA_SERVICE) ) return referenceDataService(store, next, action);
    if (action.type === SUBMIT_POLICY_REQUEST) return purchaseService(store, next, action); 
    if (action.type === GET_QUOTE_REQUEST) return quoteService(store, next, action); 
    if (action.type === SEND_LEADS_EMAIL) return sizotsaLeadsMailService(store, next, action); 
    if (action.type === SEND_UPLOAD_DOCUMENTS) return uploadDocumentService(store, next, action); 

return null
}
